import isBreakpoint from '~scripts/utility/media-query';

const FooterMenu = {
  _selectors: {
    menu: '.js-footer-menu',
    menuItemTopLevel: '.js-footer-menu-item-top-level',
    accordionItemHeader: '.js-footer-menu-accordion-item-header'
  },

  init() {
    const self = this;

    // Loops all footer menus
    document.querySelectorAll(this._selectors.menu).forEach(menuNode => {
      self.detectItemsWithShallowTreeStructure(menuNode);

      // Event listener :: Toggles Accordion
      menuNode.addEventListener('click', self.toggleAccordionItem.bind(self));

      // Adds data attribute with menu tree level count on top level menu items
      menuNode.querySelectorAll(self._selectors.menuItemTopLevel).forEach(menuItemNode => {
        menuItemNode.setAttribute('data-total-tree-levels', self.countTreeLevels( menuItemNode ));
      });
    });
  },

  toggleAccordionItem(e) {
    // Accordion should only work on smaller breakpoints
    if ( ! isBreakpoint('small-tablet') ) {
      return;
    }

    // Click was not on item header
    if ( !e.target.matches(this._selectors.accordionItemHeader) ) {
      return;
    }

    const menuItem = e.target.closest(this._selectors.menuItemTopLevel);

    // Toggle expand/collapse
    menuItem.classList.contains('expand')
      ? menuItem.classList.remove('expand')
      : menuItem.classList.add('expand')
    ;
  },

  detectItemsWithShallowTreeStructure(menuNode) {
    const self = this;

    menuNode.querySelectorAll(this._selectors.menuItemTopLevel).forEach(menuItemNode => {
      if ( menuItemNode.hasAttribute('data-mega-menu') && self.hasShallowTree(menuItemNode) ) {
        menuItemNode.classList.add('has-shallow-tree');
      }
    });
  },

  /**
   * Returns whether the current menu item has a short/long tree of descendant items
   */
  hasShallowTree(menuItemNode) {
    return this.countTreeLevels(menuItemNode) === 2;
  },

  countTreeLevels(menuItemNode) {
    let subMenuTree = {};
    menuItemNode.querySelectorAll('.js-footer-menu-submenu').forEach(subMenu => {
      const depth = parseInt(subMenu.getAttribute('data-depth'));
      subMenuTree[depth] = subMenu;
    });

    return Object.keys(subMenuTree).length;
  }
};

export default FooterMenu;